import DashboardCardList from './DashboardCardList';

const DashboardCardPage = () => {
    return <DashboardCardList />;
};

export default DashboardCardPage;
